import { render, staticRenderFns } from "./UnsavedTripCard.vue?vue&type=template&id=76b95b1b"
import script from "./UnsavedTripCard.vue?vue&type=script&lang=ts"
export * from "./UnsavedTripCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports